module.exports = __webpack_public_path__ + "img/service-flow-company.394c1f7a.png";